import { TKey } from "@/app/translations/TKey";
import { HomeRole } from "@/app/types/home/HomeRole";
import { LANDING_IMAGES_DIR } from "../ConceptFlow/ConceptFlow.logic";

export const FOR_WHO_AVATAR_SIZE = 44;
export const FOR_WHO_PHOTO_WIDTH = 800;
export const FOR_WHO_PHOTO_HEIGHT = 500;

export const HOME_ROLES: HomeRole[] = [
  {
    titleKey: TKey.HOME_WHO_LEADERS_TITLE,
    textKey: TKey.HOME_WHO_LEADERS_TEXT,
    photo: `${LANDING_IMAGES_DIR}role-leader.jpg`,
  },
  {
    titleKey: TKey.HOME_WHO_MANAGERS_TITLE,
    textKey: TKey.HOME_WHO_MANAGERS_TEXT,
    photo: `${LANDING_IMAGES_DIR}role-manager.jpg`,
  },
  {
    titleKey: TKey.HOME_WHO_SELLERS_TITLE,
    textKey: TKey.HOME_WHO_SELLERS_TEXT,
    photo: `${LANDING_IMAGES_DIR}role-seller.jpg`,
  },
  {
    titleKey: TKey.HOME_WHO_SUCCESS_TITLE,
    textKey: TKey.HOME_WHO_SUCCESS_TEXT,
    photo: `${LANDING_IMAGES_DIR}role-success.jpg`,
  },
];
